import {Reducer} from '@reduxjs/toolkit'

import {IAbsenceRequest} from '../Client/IAbsenceRequest'

import {
  ActionTypes, APPROVE_ABSENCE_REQUEST_FAILURE,
  APPROVE_ABSENCE_REQUEST_SUCCESS,
  CREATE_ABSENCE_REQUEST_FAILURE,
  CREATE_ABSENCE_REQUEST_SUCCESS,
  DELETE_ABSENCE_REQUEST_SUCCESS,
  GET_ABSENCE_REQUESTS_SUCCESS,
  GET_ABSENCE_STATISTICS_SUCCESS,
  UPDATE_ABSENCE_REQUEST_SUCCESS,
} from './ActionTypes'
import IState from './IState'

const initialState: IState = {
  list: [],
  statistics: undefined,
}

export const absenceRequestReducer: Reducer<IState, ActionTypes> = (
  state = initialState,
  action,
) => {
  let absenceRequestIndex
  switch (action.type) {
    case GET_ABSENCE_REQUESTS_SUCCESS:
      return {
        ...state,
        list: action.payload.absenceRequests,
      }
    case CREATE_ABSENCE_REQUEST_SUCCESS:
      const newList = !state.list ? [] : [...state.list]
      newList.push(action.payload.absenceRequest)

      return {
        ...state,
        list: newList,
      }

    case CREATE_ABSENCE_REQUEST_FAILURE:
      return {...state, loading: false, error: action.payload.error}

    case DELETE_ABSENCE_REQUEST_SUCCESS:
      absenceRequestIndex = state.list.findIndex(
        absenceRequest =>
          action.payload.absenceRequest.id === absenceRequest.id,
      )

      if (-1 === absenceRequestIndex) {
        return state
      }

      return {
        ...state,
        list: [
          ...state.list.slice(0, absenceRequestIndex),
          ...state.list.slice(absenceRequestIndex + 1),
        ],
      }
    case UPDATE_ABSENCE_REQUEST_SUCCESS:
    case APPROVE_ABSENCE_REQUEST_SUCCESS:
      absenceRequestIndex = state.list.findIndex(
        (absenceRequest: IAbsenceRequest) =>
          action.payload.absenceRequest.id === absenceRequest.id,
      )

      if (-1 === absenceRequestIndex) {
        return state
      }

      return {
        ...state,
        list: [
          ...state.list.slice(0, absenceRequestIndex),
          action.payload.absenceRequest,
          ...state.list.slice(absenceRequestIndex + 1),
        ],
      }

    case APPROVE_ABSENCE_REQUEST_FAILURE:
      return {...state, loading: false, error: action.payload.error}

    case GET_ABSENCE_STATISTICS_SUCCESS:
      return {
        ...state,
        statistics: action.payload.statistics,
      }
    default:
      return state
  }
}
